import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Table } from '@/lib/components/Table';
import { EmptyScreenTable } from '@/lib/v2/examples';
import { EmptyCampaignsIcon, EmptyContactsIcon } from '@/lib/v2/icons/general';

import { EmptyTableWithoutData } from '@/src/modules/CampaignsModule/components/CampaignActions/TableContainer/components/EmptyTableWithoutData';

import { useActionsTableColumns } from './hooks/useActionsTableColumns';
import { useHandleEvents } from './hooks/useHandleEvents';

import {
  atomActionsList,
  atomLoadingProcess,
  atomSelectedRows,
  atomTotalsProcess,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { useCampaignActionsStateContext } from '@/modules/CampaignsModule/contexts/CampaignActionsContext';

const ActionsTable = () => {
  const { t } = useTranslation();

  const actionsList = useAtomValue(atomActionsList);
  const loadingProcess = useAtomValue(atomLoadingProcess);
  const totalsCampaignList = useAtomValue(atomTotalsProcess);
  const setSelectedRows = useSetAtom(atomSelectedRows);

  const { totalPages, gotoPageIndex } = useCampaignActionsStateContext();
  const { actionsColumns, changeTablePage } = useActionsTableColumns();
  const { handleCreateActionByCampaign, handleClickEmptyScreenNoResult, handleRowClick } =
    useHandleEvents();

  return (
    <div className="w-full text-base text-[#364365] 2xl:text-14">
      <Table
        noNegativeMargin
        classNamePagination="px-4 mb-2"
        columns={actionsColumns}
        data={actionsList}
        emptyScreen={{
          totalCount: totalsCampaignList.total || 0,
          noResult: (
            <EmptyScreenTable
              actionText={t(
                'CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE_NO_RESULTS.emptyCampaignsActionText'
              )}
              description={t(
                'CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE_NO_RESULTS.emptyCampaignsDescription'
              )}
              image={<EmptyContactsIcon />}
              title={t('CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE_NO_RESULTS.emptyCampaignsTitle')}
              onClickAction={handleClickEmptyScreenNoResult}
            />
          ),
          noData: (
            <EmptyScreenTable
              descriptionNode={
                <EmptyTableWithoutData
                  action={t('CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE.emptyCampaignsAction')}
                  description={t(
                    'CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE.emptyCampaignsDescription'
                  )}
                  descriptionAlt={t(
                    'CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE.emptyCampaignsDescriptionAlt'
                  )}
                  onClickAction={handleCreateActionByCampaign}
                />
              }
              image={<EmptyCampaignsIcon />}
              title={t('CAMPAIGN_ACTIONS_MAIN.EMPTY_SCREEN_TABLE.emptyCampaignsTitle')}
            />
          ),
        }}
        gotoPageIndex={gotoPageIndex}
        isLoading={loadingProcess}
        setSelectedRows={setSelectedRows}
        withCheckbox={true}
        withPagination={{
          totalPages: totalPages,
          fetchData: changeTablePage,
        }}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default ActionsTable;
